import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../core/services/constants.service';
import { CommissionInputGroupComponent } from '../../../shared/components/commission-input-group/commission-input-group.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-commission-settings',
    templateUrl: './commission-settings.component.html',
    styleUrls: ['./commission-settings.component.scss']
})
export class CommissionSettingsComponent implements OnInit {
    lang: any;
    commissionSettingsForm: FormGroup;
    @ViewChild(CommissionInputGroupComponent) commissionInputGroupComponent: CommissionInputGroupComponent;
    dataSource = [{
        stage: 1,
        label: 'Unconditional',
        proportion: 0,
        absolute: 0,
        readOnly: false,
        type: 1,
        step: 0,
    }, {
        stage: 2,
        label: 'Settlement',
        proportion: 0,
        absolute: 0,
        readOnly: false,
        type: 3,
        step: 2,
    }];
    constants = Constants;
    displayedColumns = ['stage', 'milestone', 'proportion'];
    isSubmitted: any;

    units = [{ value: 1, name: { zh: '比例', en: 'Rate' } }, {
        value: 2,
        name: { zh: '数值', en: 'Fixed' }
    }];

    notEqualError: boolean;
    isInputChange: boolean = false;
    stage = 0;

    constructor(private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private httpService: HttpService,
        private toastrService: ToastrService,
        private fb: FormBuilder) {
        this.commissionSettingsForm = this.fb.group({
            selectedTotalCommissionUnit: [1],
            totalCommissionRate: [0],
            totalCommissionFixed: [0],
            stageOption: [2]
        }, {
            // validators: SumValidator()
        });
    }

    ngOnInit(): void {
        console.log(this.data.commission);
        if (this.data.commission) {
            console.log(this.data.commission);
            this.commissionSettingsForm.patchValue({
                selectedTotalCommissionUnit: this.data.commission.totalUnit,
                stageOption: this.data.commission.stageSettingList.length
            });
            if (this.data.commission.totalUnit === 1) {
                this.commissionSettingsForm.patchValue({
                    totalCommissionRate: this.data.commission.total
                });
            } else {
                this.commissionSettingsForm.patchValue({
                    totalCommissionFixed: this.data.commission.total
                });
            }
            this.stageOptionsChange({ value: this.data.commission.stageSettingList.length });
            // this.dataSource = [];
            // this.data.commission.ext.map((stage, index) => {
            //     console.log(stage);
            //     this.dataSource.unshift({
            //         stage: index + 1,
            //         label: this.dataSource.length === 1 ? 'Settled' : (index === 0 ? 'Unconditional' : 'Settlement'),
            //         proportion: 0,
            //         absolute: 0,
            //         readOnly: false
            //     });
            // });
        } else {
            this.stageOptionsChange({ value: 2 });
        }
        this.commissionSettingsForm.get('selectedTotalCommissionUnit').valueChanges.subscribe(value => {
            if (value === 1) {
                this.commissionSettingsForm.get('totalCommissionRate').setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
                this.commissionSettingsForm.get('totalCommissionRate').updateValueAndValidity();
                this.commissionSettingsForm.get('totalCommissionFixed').clearValidators();
                this.commissionSettingsForm.get('totalCommissionFixed').updateValueAndValidity();
            } else if (value === 2) {
                this.commissionSettingsForm.get('totalCommissionFixed').setValidators([Validators.required, Validators.min(0), Validators.max(99999999)]);
                this.commissionSettingsForm.get('totalCommissionFixed').updateValueAndValidity();
                this.commissionSettingsForm.get('totalCommissionRate').clearValidators();
                this.commissionSettingsForm.get('totalCommissionRate').updateValueAndValidity();

            }
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    inputTotalChange() {
        this.isInputChange = true
        this.dataSource = [];
        this.setDataSource(this.stage, !this.isInputChange)
    }

    stageOptionsChange(e) {
        console.log(e)
        this.stage = e.value;
        this.notEqualError = false;
        this.dataSource = [];
        this.setDataSource(e.value, !this.isInputChange)
    }

    setDataSource(e, type) {
        if (type) {
            switch (e) {
                case 1:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Settlement',
                        proportion: 100,
                        absolute: 100,
                        readOnly: true,
                        type: 1,
                        step: 2,
                    });
                    break;
                case 2:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Unconditional',
                        proportion: this.data.commission && this.data.commission.stageSettingList.length === 2 ? this.data.commission.stageSettingList.filter(item => item.step === 0)[0].activeValue : this.setStageValue(e, 1),
                        absolute: this.data.commission && this.data.commission.stageSettingList.length === 2 ? this.data.commission.stageSettingList.filter(item => item.step === 0)[0].activeValue : this.setStageValue(e, 1),
                        readOnly: false,
                        type: 1,
                        step: 0,
                    });
                    this.dataSource.push({
                        stage: 2,
                        label: 'Settlement',
                        proportion: this.data.commission && this.data.commission.stageSettingList.length === 2 ? this.data.commission.stageSettingList.filter(item => item.step === 1)[0].activeValue : this.setStageValue(e, 2),
                        absolute: this.data.commission && this.data.commission.stageSettingList.length === 2 ? this.data.commission.stageSettingList.filter(item => item.step === 1)[0].activeValue : this.setStageValue(e, 2),
                        readOnly: false,
                        type: 3,
                        step: 2,
                    });
                    break;
                case 3:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Unconditional',
                        proportion: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 0)[0].activeValue : this.setStageValue(e, 1),
                        absolute: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 0)[0].activeValue : this.setStageValue(e, 1),
                        readOnly: false,
                        type: 1,
                        step: 0,
                    });
                    this.dataSource.push({
                        stage: 2,
                        label: 'Manual Activation',
                        proportion: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 1)[0].activeValue : this.setStageValue(e, 2),
                        absolute: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 1)[0].activeValue : this.setStageValue(e, 2),
                        readOnly: false,
                        type: 2,
                        step: 1,
                    });
                    this.dataSource.push({
                        stage: 3,
                        label: 'Settlement',
                        proportion: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 2)[0].activeValue : this.setStageValue(e, 3),
                        absolute: this.data.commission && this.data.commission.stageSettingList.length === 3 ? this.data.commission.stageSettingList.filter(e => e.step == 2)[0].activeValue : this.setStageValue(e, 3),
                        readOnly: false,
                        type: 3,
                        step: 2,
                    });
                    break;
                default:
                    break;
            }
        } else {
            switch (e) {
                case 1:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Settlement',
                        proportion: 100,
                        absolute: 100,
                        readOnly: true,
                        type: 1,
                        step: 2,
                    });
                    break;
                case 2:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Unconditional',
                        proportion: Number(this.setStageValue(e, 1)),
                        absolute: Number(this.setStageValue(e, 1)),
                        readOnly: false,
                        type: 1,
                        step: 0,
                    });
                    this.dataSource.push({
                        stage: 2,
                        label: 'Settlement',
                        proportion: Number(this.setStageValue(e, 2)),
                        absolute: Number(this.setStageValue(e, 2)),
                        readOnly: false,
                        type: 3,
                        step: 2,
                    });
                    break;
                case 3:
                    this.dataSource.push({
                        stage: 1,
                        label: 'Unconditional',
                        proportion: Number(this.setStageValue(e, 1)),
                        absolute: Number(this.setStageValue(e, 1)),
                        readOnly: false,
                        type: 1,
                        step: 0,
                    });
                    this.dataSource.push({
                        stage: 2,
                        label: 'Manual Activation',
                        proportion: Number(this.setStageValue(e, 2)),
                        absolute: Number(this.setStageValue(e, 2)),
                        readOnly: false,
                        type: 2,
                        step: 1,
                    });
                    this.dataSource.push({
                        stage: 3,
                        label: 'Settlement',
                        proportion: Number(this.setStageValue(e, 3)),
                        absolute: Number(this.setStageValue(e, 3)),
                        readOnly: false,
                        type: 3,
                        step: 2,
                    });
                    break;
                default:
                    break;
            }
        }
    }

    setStageValue(stage, index) {
        const total = this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? this.commissionSettingsForm.get('totalCommissionRate').value : this.commissionSettingsForm.get('totalCommissionFixed').value
        if (stage == 2 && index == 1) {
            return Number(total * 0.5).toFixed(2)
        }
        if (stage == 2 && index == 2) {
            return Number(total - Number(this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? this.dataSource[0].proportion : this.dataSource[0].absolute)).toFixed(2)
        }
        if (stage == 3 && index == 1) {
            return Number(total * 0.3333).toFixed(2)
        }
        if (stage == 3 && index == 2) {
            return Number(total * 0.3333).toFixed(2)
        }
        if (stage == 3 && index == 3) {
            return Number(total - (Number(this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? this.dataSource[0].proportion : this.dataSource[0].absolute) + Number(this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? this.dataSource[1].proportion : this.dataSource[1].absolute))).toFixed(2)
        }
    }

    createOrUpdateCommissionSettings() {
        this.isSubmitted = true;
        this.notEqualError = false;
        if (this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1) {
            let sum = 0;
            this.dataSource.map(stage => {
                sum = Number(stage.proportion) + sum;
            });
            sum = Number(sum.toFixed(2))
            this.notEqualError = this.commissionSettingsForm.get('totalCommissionRate').value !== sum && this.dataSource.length > 1;
        } else {
            let sum = 0;
            this.dataSource.map(stage => {
                sum = Number(stage.absolute) + sum;
            });
            sum = Number(sum.toFixed(2))
            this.notEqualError = this.commissionSettingsForm.get('totalCommissionFixed').value !== sum && this.dataSource.length > 1;
        }

        if (this.commissionSettingsForm.invalid || this.notEqualError) {
            return;
        }
        // const agencyIds = [];
        // const activeTypes = [];
        const activeValue = [];
        // const step = [];
        // const groupName = [];

        this.dataSource.map((item, index) => {
            // activeTypes.push(1);
            // step.push(item.stage - 1);

            if (this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1) {
                if (this.dataSource.length === 1) {
                    activeValue.push(this.commissionSettingsForm.get('totalCommissionRate').value);
                    // groupName.push({
                    //     activeType: 1,
                    //     activeValue: this.commissionSettingsForm.get('totalCommissionRate').value,
                    //     step: item.stage - 1,
                    // });
                } else {
                    activeValue.push(item.proportion);
                    // groupName.push({
                    //     activeType: 1,
                    //     activeValue: item.proportion,
                    //     step: item.stage - 1,
                    // });
                }
            } else {
                if (this.dataSource.length === 1) {
                    activeValue.push(this.commissionSettingsForm.get('totalCommissionFixed').value);
                    // groupName.push({
                    //     activeType: 2,
                    //     activeValue: this.commissionSettingsForm.get('totalCommissionFixed').value,
                    //     step: item.stage - 1,
                    // });
                } else {
                    activeValue.push(item.absolute);
                    // groupName.push({
                    //     activeType: 2,
                    //     activeValue: item.absolute,
                    //     step: item.stage - 1,
                    // });
                }
            }
        });
        // const fd = new FormData();
        // if (this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1) {
        //     fd.append('total', this.commissionSettingsForm.get('totalCommissionRate').value);
        //     fd.append('totalUnit', '1');
        //
        // } else {
        //     fd.append('total', this.commissionSettingsForm.get('totalCommissionFixed').value);
        //     fd.append('totalUnit', '2');
        // }
        // agencyIds.push(this.data.agencyId);
        // fd.append('projectId', this.data.projectId);
        // fd.append('agentCompanyIds', agencyIds.toString());
        // fd.append('activeType', activeTypes.toString());
        // fd.append('activeValue', activeValue.toString());
        // fd.append('step', step.toString());
        // fd.append('groupName', this.dataSource.length.toString());

        // 设置佣金

        let submitData = {
            total: this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? this.commissionSettingsForm.get('totalCommissionRate').value : this.commissionSettingsForm.get('totalCommissionFixed').value,
            totalUnit: this.commissionSettingsForm.get('selectedTotalCommissionUnit').value,
            groupName: this.dataSource.length.toString(),
            stageSettingList: [],
        }
        this.dataSource.map((data, index) => {
            let item = {
                activeType: data.type,
                activeValue: this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1 ? data.proportion : this.dataSource.length === 1 ? this.commissionSettingsForm.get('totalCommissionFixed').value : data.absolute,
                step: index,
            }
            submitData.stageSettingList.push(item)
        })
        this.httpService.modifyCommissionStageSetting(this.data.projectId, this.data.agencyId, submitData).subscribe((res: any) => {
            this.dialogRef.close(res.code)
        })


        // if (this.data.commission) {
        //     // Update commission
        //     fd.append('id', this.data.commission.id);
        //     this.httpService.updateCommissionStageSetting(this.data.commission.id, fd).subscribe((res: any) => {
        //         console.log(res);
        //         this.dialogRef.close(res.code);
        //     });
        // } else {
        //     // Create commission
        //     this.httpService.createCommissionStageSetting(fd).subscribe((res: any) => {
        //         console.log(res);
        //         this.dialogRef.close(res.code);
        //     });
        // }


    }

    // hasTotalBonusChange(e) {
    //   console.log(e);
    //   if (e.checked) {
    //     this.commissionSettingsForm.get('totalBonus').enable();
    //   } else {
    //     // this.commissionSettingsForm.get('totalBonus').disable();
    //     this.commissionSettingsForm.get('totalBonus').reset({value: '', disabled: true});
    //   }
    // }


}
